var VCA = VCA || {};

VCA.MyVCALogin = (function ($) {

    const password = $('.login-password-input');
    const loginErrMessage = $('.validation-summary-errors');
    const loginErrorMessage  = $('.login-error');
    const loginModal = $('#LoginRedirectModal');
    const duration = $('#LoginRedirectModal').data('duration');
   
    function bindEvents() {
        $('#togglePassword').on('click', togglePassword);
        $('.login-btn[type="submit"]').on('click', displayLoadingSpinner);
    }

    function checkErrorMessage() {
        if (loginErrMessage.length > 0) { 
            let listedItemEl = $(loginErrMessage).find('ul li')[0];
            let elHasHttps = $(listedItemEl).html().includes('https');
            let redirectPath = $(listedItemEl).html();
            let durationInMilliseconds = duration * 1000;

            if (elHasHttps) {
                $(loginModal).modal('show');

                setTimeout(() => {
                    $(loginModal).modal('hide');
                    window.location.href = redirectPath;
                }, durationInMilliseconds);

            } else {
                loginErrorMessage.html($(listedItemEl).html());
                loginErrorMessage.show();
                window.VCA.AccountDatalayer.dataLayerLoginFailure();
            }   
        }
    }

    function togglePassword() {
        const type = $(password).attr('type') === 'password' ? 'text' : 'password';
        $(password).attr('type', type);
        $(this).toggleClass('fa-eye-slash');
    }

    function displayLoadingSpinner() {
        let email = $('.login-email-input').val();
        let emailRegex = /(^[a-zA-Z0-9_.]+[@]{1}[a-zA-Z0-9\-]+[\.][a-zA-Z]+$)/;
        let validateEmail = emailRegex.test(email);
        let passwordLength = $('.login-password-input').val().length > 5;

        $('.login-error').hide();

        if (!validateEmail || !passwordLength) {
            return
        }
        $('.js-account-step').css('pointer-events', 'none');
        $('.login-loadingspinner-wrapper').show();
    }

    function init() {
        if ($('.myvca-login-page').length <= 0) {
            return;
        }

        checkErrorMessage();
        bindEvents();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.MyVCALogin.init();
});